const state = {
  list: [],
  selectedCategory: null,
};

const getters = {
  customerCategories: (state) => state.list,
  lowLevelCategories: (state) =>
    (state.list = state.list.map((category) => {
      category.allowed = true;
      if (category.level === "L") {
        category.allowed = false;
      }
      return category;
    })),
  moderateLevelCategories: (state) =>
    (state.list = state.list.map((category) => {
      category.allowed = true;
      if (category.level === "L" || category.level === "M") {
        category.allowed = false;
      }
      return category;
    })),
  highLevelCategories: (state) =>
    (state.list = state.list.map((category) => {
      category.allowed = true;
      if (
        category.level === "L" ||
        category.level === "M" ||
        category.level === "H"
      ) {
        category.allowed = false;
      }
      return category;
    })),
};

const actions = {
  async fetchPolicyCategories({ commit }, { id, policyId }) {
    const response = await this._vm.$http.get(
      `/restapi/policies/${policyId}/categories?user_id=${id}&list_locations=false&show_first_location=true&show_locations_count=true`
    );
    response.data.data.map((res) => {
      if (!res.allowed) {
        res.allowed = true;
      } else {
        res.allowed = false;
      }
    });
    commit("setCategories", response.data);
  },

  async fetchSpecificPolicyCategories({ commit }, { id, policyId }) {
    const response = await this._vm.$http.get(
      `/restapi/policies/${policyId}?user_id=${id}`
    );
    commit("setSelectedCategory", response.data);
    commit("updateCategories", response.data);
  },

  async updateCustomerCategorySettings(
    { commit },
    { id, policyId, categorySettings }
  ) {
    const response = await this._vm.$http.put(
      `/restapi/policies/${policyId}/categories?user_id=${id}`,
      categorySettings
    );
    commit("updateCategory", response.data);
  },

  async updateCustomerSpecificCategory(
    { commit },
    { id, policyId, categorySettings }
  ) {
    categorySettings.map((res) => {
      if (res.allowed) {
        res.allowed = false;
      } else {
        res.allowed = true;
      }
    });
    const response = await this._vm.$http.put(
      `/restapi/policies/${policyId}/categories?user_id=${id}`,
      categorySettings
    );
    response.data.data.map((res) => {
      if (!res.allowed) {
        res.allowed = true;
      } else {
        res.allowed = false;
      }
    });
    commit("updateCategories", response.data.data);
  },
};

const mutations = {
  setCategories: (state, data) => (state.list = data.data),
  addCategory: (state, data) => state.list.push(data),
  setSelectedCategory: (state, data) => (state.selectedCategory = data.data),
  updateCategories: (state, data) => {
    const updateIds = data.map((category) => category.id);
    state.list = state.list.map((policy) => {
      const policyIndex = updateIds.indexOf(policy.id);
      if (updateIds && policyIndex > -1) {
        return { ...policy, ...data[`${policyIndex}`] };
      }
      return policy;
    });
  },
  updateCategory: (state, data) =>
    (state.list = state.list.map((policy) => {
      if (policy.id === data.id) return { ...policy, ...data };
      return policy;
    })),
  deleteCategory: (state, data) =>
    (state.list = state.list.filter((policy) => policy.id !== data.id)),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
